import { render, staticRenderFns } from "./formulir-ls.vue?vue&type=template&id=5ac49de6&"
import script from "./formulir-ls.vue?vue&type=script&lang=js&"
export * from "./formulir-ls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports